import { React, DomeComponent } from "@lexriver/dome";
import { EnumIconNames } from "../enums/EnumIconNames";

interface Attrs{
    iconName:EnumIconNames
}

export class Icon extends DomeComponent<Attrs>{
    render() {
        return <span class={this.attrs.iconName} />
    }
}